import React, { Suspense } from 'react';
import { showCornerStone } from '@benzinga/navigation-ui';
import { MoneyTemplateProps } from '../../entities';
import { MoneyPostLayout } from '../MoneyPostLayout';
import { MoneyHeader } from '../MoneyHeader';
import classNames from 'classnames';
import { PageCampaigns } from '../Campaign/PageCampaigns';
import { CmsStyles } from './CmsStyles';
import styles from './MoneyPostTemplate.module.css';

export const MoneyPostTemplate: React.FC<MoneyTemplateProps> = ({
  layoutAboveArticle,
  layoutBelowArticle,
  layoutHeader,
  layoutMainClassName,
  post,
  showMoneyHeader = true,
  sidebarSettings,
}) => {
  const layout = showCornerStone(post ?? null) ? 'wide' : 'narrow';
  const isSimpleLayout = !!post?.layout?.settings?.simple_article_title;

  return (
    <div
      className={classNames(styles.wrapper, {
        [layout]: !!layout,
        [styles.simpleLayout]: isSimpleLayout,
      })}
    >
      {post?.post_type === 'advertorial' && !post?.layout?.settings?.disable_top_disclosure && (
        <div className="flex bg-bzblue-700 justify-center center text-sm text-white p-2 gap-1">
          This is a Paid Advertisement.{' '}
          <a className="text-white underline" href="#17bdisclosurelink">
            See 17b Disclosure Below.
          </a>
        </div>
      )}
      {layoutHeader || (showMoneyHeader && post && <MoneyHeader post={post} />)}
      <MoneyPostLayout
        layoutAboveArticle={layoutAboveArticle}
        layoutBelowArticle={layoutBelowArticle}
        layoutMainClassName={layoutMainClassName}
        maxWidth={layout === 'wide' ? '1400px' : '1100px'}
        post={post ?? null}
        sidebarSettings={sidebarSettings}
      />
      <Suspense fallback={<div />}>
        <PageCampaigns post={post} />
      </Suspense>
      <CmsStyles styles={post?.styles} />
    </div>
  );
};

export default MoneyPostTemplate;
